import './scss/main.scss';



// FloatingMenu
import './js/FloatingMenu.js';



// js/verkauferForm
// import './js/verkauferForm.js';


// js/message
import './js/message.js';
import './js/okopunktMessageBoard.js';
// blocks
// sticky header
import './js/stickyHeader.js';

import './js/ecopointsDropdown.js';
// js/interested.js
import './js/interested.js';
// navigation
import './js/navigation.js';
// jagd dropdown listings
import './js/jagdDropdownListings.js';


import './js/toc.js';

import './js/TopBar.js';





// map
// import './js/okopunktMap/map.js';
// jagdMap
// import initializeJagdMap from './js/jagdMap/map.js';
// okopunktMarketMap
// import './js/okopunktJagdCombinedMap/map.js';
// smoothScroll
import './js/smoothScroll.js';





function ensureJagdMapInitialization() {
    const mapElement = document.querySelector('.da__dmap-jagd');

    if (mapElement) {
        console.log('.da__dmap-jagd container found. Initializing map...');
        import('./js/jagdMap/map.js')
            .then(({ initializeJagdMap }) => initializeJagdMap())
            .catch(error => console.error('Failed to load Jagd Map:', error));
    } else {
        console.warn('.da__dmap-jagd container not found. Watching for DOM changes...');
        watchForElement('.da__dmap-jagd', () => {
            console.log('.da__dmap-jagd container dynamically added. Initializing map...');
            import('./js/jagdMap/map.js')
                .then(({ initializeJagdMap }) => initializeJagdMap())
                .catch(error => console.error('Failed to load Jagd Map:', error));
        });
    }
}

function ensureCombinedMapInitialization() {
    const mapElement = document.querySelector('.da__combined-map');

    if (mapElement) {
        console.log('.da__combined-map container found. Initializing map...');
        import('./js/okopunktJagdCombinedMap/map.js')
            .then(({ initializeCombinedMap }) => initializeCombinedMap())
            .catch(error => console.error('Failed to load Combined Map:', error));
    } else {
        console.warn('.da__combined-map container not found. Watching for DOM changes...');
        watchForElement('.da__combined-map', () => {
            console.log('.da__combined-map container dynamically added. Initializing map...');
            import('./js/okopunktJagdCombinedMap/map.js')
                .then(({ initializeCombinedMap }) => initializeCombinedMap())
                .catch(error => console.error('Failed to load Combined Map:', error));
        });
    }
}

// Add initialization for the Okopunkt Map (third map)
function ensureOkopunktMapInitialization() {
    const mapElement = document.querySelector('.da__map-okopunkt');

    if (mapElement) {
        console.log('.da__map-okopunkt container found. Initializing map...');
        import('./js/okopunktMap/map.js')
            .then(({ initializeOkopunktMap }) => initializeOkopunktMap())
            .catch(error => console.error('Failed to load Okopunkt Map:', error));
    } else {
        console.warn('.da__map-okopunkt container not found. Watching for DOM changes...');
        watchForElement('.da__map-okopunkt', () => {
            console.log('.da__map-okopunkt container dynamically added. Initializing map...');
            import('./js/okopunktMap/map.js')
                .then(({ initializeOkopunktMap }) => initializeOkopunktMap())
                .catch(error => console.error('Failed to load Okopunkt Map:', error));
        });
    }
}

function watchForElement(selector, callback) {
    const targetNode = document.body;

    const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
            callback();
            observer.disconnect(); // Stop observing after element is found
        }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
}


// window.addEventListener('load', function () {
//     // if (window.BorlabsCookie && BorlabsCookie.Consents.hasConsent('borlabs-cookie')) {
//         console.log('Consent already given for borlabs-cookie. Initializing maps...');
//         ensureOkopunktMapInitialization();
//         ensureJagdMapInitialization();
//         ensureCombinedMapInitialization();
//     // }

//     document.addEventListener('borlabs-cookie-consent-saved', function () {
//         // if (BorlabsCookie.Consents.hasConsent('borlabs-cookie')) {
//             console.log('Consent given for borlabs-cookie. Initializing maps...');
//             ensureOkopunktMapInitialization();
//             ensureJagdMapInitialization();
//             ensureCombinedMapInitialization();
//         // }
//     });
// });


window.addEventListener('load', function () {
    // ✅ These work correctly – do not remove
    ensureCombinedMapInitialization();
    ensureOkopunktMapInitialization();
    ensureJagdMapInitialization();

    // ✅ Run again if consent is granted after load
    document.addEventListener('borlabs-cookie-consent-saved', function () {
        ensureCombinedMapInitialization();
        ensureOkopunktMapInitialization();
        ensureJagdMapInitialization();
    });
});




// Event listener for Borlabs Cookie consent
// window.addEventListener('load', function () {
//     if (window.BorlabsCookie && BorlabsCookie.Consents.hasConsent('borlabs-cookie')) {
//         console.log('Consent already given for borlabs-cookie. Checking maps...');
//         ensureJagdMapInitialization();
//         ensureCombinedMapInitialization();
//         ensureOkopunktMapInitialization(); // Initialize Okopunkt map
//     }

//     document.addEventListener('borlabs-cookie-consent-saved', function () {
//         if (BorlabsCookie.Consents.hasConsent('borlabs-cookie')) {
//             console.log('Consent given for borlabs-cookie. Checking maps...');
//             ensureJagdMapInitialization();
//             ensureCombinedMapInitialization();
//             ensureOkopunktMapInitialization(); // Initialize Okopunkt map
//         }
//     });
// });
